import "@fontsource/instrument-serif/400.css";
import "@fontsource-variable/recursive/index.css";
import "./styles.css";

function renderBootFailure(error: unknown) {
  console.error("UCU landing page failed to start.", error);
  const root = document.getElementById("root");
  if (!root) return;

  const container = document.createElement("main");
  container.className = "boot-failure";
  const heading = document.createElement("h1");
  heading.textContent = "Universal Computer Use could not start";
  const message = document.createElement("p");
  message.textContent = "Refresh the page. If the problem continues, contact support with the page URL.";
  container.append(heading, message);

  if (window.location.hostname === "127.0.0.1" || window.location.hostname === "localhost") {
    const details = document.createElement("pre");
    details.textContent = error instanceof Error ? `${error.name}: ${error.message}\n${error.stack || ""}` : String(error);
    container.append(details);
  }

  root.replaceChildren(container);
}

void import("./bootstrap").catch(renderBootFailure);
